import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginDto } from '../model-dto/login.dto';
import { ENVIRONMENT } from '@wayout-admin/util';

@Injectable({ providedIn: 'root' })
export class AuthHttpService {
	private readonly http = inject(HttpClient);
	private readonly environment = inject(ENVIRONMENT);
	private readonly baseUrl = `${this.environment.baseApiUrl}/admin/auth`;

	login(username: string, password: string): Observable<LoginDto> {
		return this.http.post<LoginDto>(`${this.baseUrl}/login`, { username, password });
	}
}
